<template>
  <div class="d-flex flex-column gap-12 mb-6">
    <divcard>
      <div class="card-part">
        <div class="txt-head black--text mb-2">
          <span class="theme-color-one">ส่วนที่ 2 :</span> ข้อมูลบริษัท/หน่วยงาน
        </div>
        <!-- Form 1 -->
        <div class="txt-head black--text mb-2">1. ข้อมูลบริษัท/หน่วยงาน</div>
        <!-- block 1 -->
        <div class="flex-center gap-16">
          <div class="flex">
            <div class="mb-1 black--text">ชื่อบริษัท (ภาษาไทย)</div>
            <TextField
              theme="3"
              :value="form.company_name_th"
              @onChange="setFormField('company_name_th', $event)"
            >
            </TextField>
          </div>

          <div class="flex">
            <div class="mb-1 black--text">ชื่อบริษัท (ภาษาอังกฤษ)</div>
            <TextField
              theme="3"
              :value="form.company_name_eng"
              @onChange="setFormField('company_name_eng', $event)"
            >
            </TextField>
          </div>
        </div>
        <!-- block 2 -->
        <div>
          <div class="mb-1 black--text">
            ที่อยู่สำนักงานใหญ่ (Head Office Address)
          </div>
          <TextField
            theme="3"
            :value="form.headquarters_address"
            @onChange="setFormField('headquarters_address', $event)"
          >
          </TextField>
        </div>
        <!-- block 3 -->
        <div class="flex-center gap-16">
          <div class="flex">
            <div class="mb-1 black--text">รหัสไปรษณีย์ (Postal Code)</div>
            <TextField
              theme="3"
              :rules="zipCodeRules"
              input-type="number"
              :value="form.headquarters_postal_code"
              @onChange="setFormField('headquarters_postal_code', $event)"
            >
            </TextField>
          </div>
          <div class="flex">
            <div class="mb-1 black--text">โทรศัพท์ (Telephone No.)</div>
            <TextField
              placeholder="02XXXXXXX"
              theme="3"
              input-type="number"
              :value="form.headquarters_phone"
              @onChange="setFormField('headquarters_phone', $event)"
            >
            </TextField>
          </div>
          <div class="flex">
            <div class="mb-1 black--text">โทรสาร (Facsimile No.)</div>
            <TextField
              theme="3"
              input-type="number"
              :value="form.headquarters_fac"
              @onChange="setFormField('headquarters_fac', $event)"
            >
            </TextField>
          </div>
          <div class="flex">
            <div class="mb-1 black--text">อีเมล (E-mail)</div>
            <TextField
              theme="3"
              :rules="emailRules"
              :value="form.headquarters_email"
              @onChange="setFormField('headquarters_email', $event)"
            >
            </TextField>
          </div>
        </div>
        <!-- block 4 -->
        <div>
          <div class="mb-1 black--text">เว็บไซต์ (Website)</div>
          <TextField
            :rules="websiteRules"
            theme="3"
            :value="form.headquarters_website"
            @onChange="setFormField('headquarters_website', $event)"
          >
          </TextField>
        </div>
      </div>
    </divcard>
    <divcard>
      <div class="txt-head black--text mb-2">
        2. ข้อมูลผู้ติดต่อประสานงาน (Contact Person)
      </div>
      <!-- block 1 -->
      <div class="flex-center gap-16">
        <div class="flex">
          <div class="mb-1 black--text">ชื่อ-สกุล (Name)</div>
          <TextField
            theme="3"
            :value="form.contact_name"
            @onChange="setFormField('contact_name', $event)"
          >
          </TextField>
        </div>

        <div class="flex">
          <div class="mb-1 black--text">ตำแหน่ง (Position)</div>
          <TextField
            theme="3"
            :value="form.contact_position"
            @onChange="setFormField('contact_position', $event)"
          >
          </TextField>
        </div>
      </div>
      <!-- block 2 -->
      <div>
        <div class="mb-1 black--text">ที่อยู่ (Address)</div>
        <TextField
          theme="3"
          :value="form.contact_address"
          @onChange="setFormField('contact_address', $event)"
        >
        </TextField>
      </div>
      <!-- block 3 -->
      <div class="flex-center gap-16">
        <div class="flex">
          <div class="mb-1 black--text">โทรสาร (Facsimile No.)</div>
          <TextField
            theme="3"
            input-type="number"
            :value="form.contact_fac"
            @onChange="setFormField('contact_fac', $event)"
          >
          </TextField>
        </div>
        <div class="flex">
          <div class="mb-1 black--text">มือถือ (Mobile Phone)</div>
          <TextField
            placeholder="09XXXXXXXX"
            :rules="mobilePhoneRules"
            theme="3"
            input-type="number"
            :value="form.contact_phone"
            @onChange="setFormField('contact_phone', $event)"
          >
          </TextField>
        </div>
        <div class="flex">
          <div class="mb-1 black--text">อีเมล (E-mail)</div>
          <TextField
            theme="3"
            :rules="emailRules"
            :value="form.contact_email"
            @onChange="setFormField('contact_email', $event)"
          >
          </TextField>
        </div>
      </div>
    </divcard>
    <divcard>
      <div class="card-part">
        <div class="txt-head black--text mb-2">
          3. ข้อมูลการจดทะเบียนบริษัท (Company Registration Information)
        </div>
        <div class="black--text mb-2">3.1 ข้อมูลผู้ประสานงานโครงการ</div>
        <div class="flex-center gap-16">
          <div class="flex">
            <div class="mb-1 black--text">
              ทะเบียนเลขที่ (Company Registration Number)
            </div>
            <TextField
              input-type="number"
              theme="3"
              :value="form.registration_number"
              @onChange="setFormField('registration_number', $event)"
            >
            </TextField>
          </div>

          <div class="flex">
            <div class="mb-1 black--text">
              วันที่จดทะเบียน (Company Registration Date)
            </div>
            <DatePicker
              :value="form.registration_date"
              @onInput="
                form.registration_date = $event;
                $forceUpdate();
              "
            ></DatePicker>
          </div>
        </div>
      </div>
      <div class="card-part">
        <div class="black--text mb-2">
          3.2 ทุนจดทะเบียน (Registered Capital)
        </div>
        <div class="flex-center gap-16">
          <div class="flex">
            <div class="mb-1 black--text">
              ทุนจดทะเบียน (Registered Capital)
            </div>
            <TextField
              input-type="number"
              theme="3"
              :value="form.registration_capital"
              @onChange="setFormField('registration_capital', $event)"
            >
            </TextField>
          </div>
        </div>
      </div>
      <div class="card-part">
        <div class="black--text mb-2">3.3 ขนาดของธุรกิจ</div>
        <div>
          <v-radio-group
            row
            style="width: 100%"
            v-model="form.business_size_id"
          >
            <v-row>
              <v-col
                v-for="(item, index_business_size) in masterData?.business_size"
                :key="index_business_size"
                cols="6"
              >
                <v-radio
                  color="var(--theme-color-one)"
                  :label="item.name"
                  :value="item.id"
                  class="pl-5"
                ></v-radio>
              </v-col>
            </v-row>
          </v-radio-group>
        </div>
      </div>
      <div class="card-part d-flex justify-space-between">
        <div class="black--text mb-2">
          3.4 กรรมการผู้มีอำนาจลงนามของบริษัท (Authorized person of company)
        </div>
        <Button @onClick="addPerson" theme="500" prepend-icon="mdi-plus"
          >เพิ่มกรรมการผู้มีอำนาจลงนาม</Button
        >
      </div>
    </divcard>
    <divcard
      v-for="(person, index) in form.area_form_2_3"
      :key="'area_form_2_3' + index"
      class="mx-7"
    >
      <div class="mb-1 black--text">
        {{ "3.4." + (index + 1) + " บุคคลที่ " + (index + 1) }}
      </div>
      <v-btn
        icon
        absolute
        top
        right
        style="z-index: 99"
        @click="delPerson(index)"
      >
        <Iconify
          class="font-18"
          style="color: #b1b1b1"
          icon="mdi:close-circle"
        />
      </v-btn>
      <div>
        <div class="flex-center gap-16">
          <div class="flex">
            <div class="mb-1 black--text">ชื่อ - สกุล (Name)</div>
            <TextField
              theme="3"
              :value="person.name"
              @onChange="setPersonField('name', index, $event)"
            >
            </TextField>
          </div>

          <div class="flex">
            <div class="mb-1 black--text">ตำแหน่ง (Position)</div>
            <TextField
              theme="3"
              :value="person.position"
              @onChange="setPersonField('position', index, $event)"
            >
            </TextField>
          </div>
        </div>
        <div class="flex-center gap-16">
          <div class="flex">
            <div class="mb-1 black--text">โทรศัพท์ (TelePhone No.)</div>
            <TextField
              placeholder="02XXXXXXX"
              theme="3"
              input-type="number"
              :value="person.phone"
              @onChange="setPersonField('phone', index, $event)"
            >
            </TextField>
          </div>

          <div class="flex">
            <div class="mb-1 black--text">มือถือ (Mobile Phone)</div>
            <TextField
              placeholder="09XXXXXXXX"
              :rules="mobilePhoneRules"
              theme="3"
              input-type="number"
              :value="person.mobile_phone"
              @onChange="setPersonField('mobile_phone', index, $event)"
            >
            </TextField>
          </div>
        </div>
        <div>
          <div class="mb-1 black--text">อีเมล (Email)</div>
          <TextField
            theme="3"
            :rules="emailRules"
            :value="person.email"
            @onChange="setPersonField('email', index, $event)"
          >
          </TextField>
        </div>
      </div>
    </divcard>
    <divcard>
      <div class="txt-head black--text mb-2">
        4. ข้อมูลเกี่ยวกับบริษัทแม่/บริษัทร่วมทุน (ถ้ามี) (Headquarter/Joint
        Venture Company Information (If any))
      </div>
      <div class="flex-center gap-16">
        <div class="flex">
          <div class="mb-1 black--text">ชื่อบริษัท (Company Name)</div>
          <TextField
            theme="3"
            :value="form.headquarters_joint_name"
            @onChange="setFormField('headquarters_joint_name', $event)"
          >
          </TextField>
        </div>

        <div class="flex">
          <div class="mb-1 black--text">สัญชาติ (Nationality)</div>
          <TextField
            theme="3"
            :value="form.headquarters_joint_nationality"
            @onChange="setFormField('headquarters_joint_nationality', $event)"
          >
          </TextField>
        </div>
      </div>
      <div class="flex-center gap-16">
        <div class="flex">
          <div class="mb-1 black--text">ประเทศที่ตั้ง (Located Country)</div>
          <TextField
            theme="3"
            :value="form.headquarters_joint_country"
            @onChange="setFormField('headquarters_joint_country', $event)"
          >
          </TextField>
        </div>

        <div class="flex">
          <div class="mb-1 black--text">ทุนจดทะเบียน (Registered Capital)</div>
          <TextField
            input-type="number"
            theme="3"
            :value="form.headquarters_joint_capital"
            @onChange="setFormField('headquarters_joint_capital', $event)"
          >
          </TextField>
        </div>
      </div>
      <div>
        <div class="mb-1 black--text">เว็บไซต์ (Website)</div>
        <TextField
          :rules="websiteRules"
          theme="3"
          :value="form.headquarters_joint_website"
          @onChange="setFormField('headquarters_joint_website', $event)"
        >
        </TextField>
      </div>
    </divcard>
    <divcard>
      <div class="txt-head black--text mb-2">
        5. ประเภทอุตสาหกรรม (Industry Category)
      </div>
      <div class="d-flex" style="width: 100%">
        <v-row>
          <v-col cols="4">
            <CheckBox
              style="max-width: unset"
              :input-value="form.industry_food"
              @onChange="form.industry_food = $event"
              >Food and Agriculture</CheckBox
            >
          </v-col>
          <v-col cols="4">
            <CheckBox
              style="max-width: unset"
              :input-value="form.industry_ict"
              @onChange="form.industry_ict = $event"
              >ICT and Software</CheckBox
            >
          </v-col>
          <v-col cols="4">
            <CheckBox
              style="max-width: unset"
              :input-value="form.industry_science"
              @onChange="form.industry_science = $event"
              >Science as a Service</CheckBox
            >
          </v-col>
        </v-row>
      </div>
      <div class="d-flex" style="width: 100%">
        <v-row>
          <v-col cols="4">
            <CheckBox
              style="max-width: unset"
              :input-value="form.industry_materials"
              @onChange="form.industry_materials = $event"
              >Materials Science and Chemicals</CheckBox
            >
          </v-col>
          <v-col cols="4">
            <CheckBox
              style="max-width: unset"
              :input-value="form.industry_electronics"
              @onChange="form.industry_electronics = $event"
              >Electronics, Robotics and Automation</CheckBox
            >
          </v-col>
          <v-col cols="4">
            <CheckBox
              style="max-width: unset"
              :input-value="form.industry_medical"
              @onChange="form.industry_medical = $event"
              >Medical Device and Pharmaceutical</CheckBox
            >
          </v-col>
        </v-row>
      </div>
      <div class="d-flex" style="width: 100%">
        <v-row>
          <v-col cols="4">
            <CheckBox
              style="max-width: unset"
              :input-value="form.industry_auto"
              @onChange="form.industry_auto = $event"
              >Auto Parts</CheckBox
            >
          </v-col>
          <v-col cols="4" class="d-flex gap-16">
            <CheckBox
              style="max-width: unset"
              :input-value="form.industry_others"
              @onChange="form.industry_others = $event"
              >Other</CheckBox
            >
            <TextField
              :disabled="!form.industry_others"
              theme="3"
              :value="form.industry_others_specify"
              @onChange="setFormField('industry_others_specify', $event)"
            >
            </TextField>
          </v-col>
        </v-row>
      </div>
    </divcard>
    <divcard>
      <div class="txt-head black--text mb-2">
        6. เหตุผลในการเลือกอยู่อาคารอำนวยการอุทยานวิทยาศาสตร์
      </div>
      <div class="mb-1 black--text">
        เหตุผลในการเลือกอยู่อาคารอำนวจการอุทยานวิทยาศาสตร์
      </div>
      <TextField
        theme="3"
        :value="form.reason_choose"
        @onChange="setFormField('reason_choose', $event)"
      >
      </TextField>
    </divcard>
    <divcard>
      <div class="txt-head black--text mb-2">7. ประเภทผู้ใช้บริการพื้นที่</div>
      <div class="mb-1 black--text">ประเภทผู้ใช้บริการพื้นที่</div>
      <v-radio-group style="width: 100%" v-model="form.area_type_id">
        <v-radio
          v-for="(item, index) in masterData?.type"
          :key="index"
          :label="item.name"
          :value="item.id"
          color="var(--theme-color-one)"
          class="pl-5"
        ></v-radio>
      </v-radio-group>
    </divcard>
    <!-- <divcard>
      <div class="txt-head black--text mb-2">
        8. ความต้องการใช้พื้นที่ (อาคาร)
      </div>
      <TextField
        theme="3"
        :value="form.spaceRequirements"
        @onChange="setFormField('spaceRequirements', $event)"
      >
      </TextField>
    </divcard>
    <divcard>
      <div class="txt-head black--text mb-2">
        9. ความต้องการใช้พื้นที่ (ชั้น)
      </div>
      <TextField
        theme="3"
        :value="form.floorRequirements"
        @onChange="setFormField('floorRequirements', $event)"
      >
      </TextField>
    </divcard> -->
    <divcard>
      <div class="card-part d-flex justify-space-between">
        <div class="txt-head black--text mb-2">
          8. ลำดับความต้องการของตำแหน่งห้อง (Prioritize your favorite room)
        </div>
        <Button @onClick="addPrioritize" theme="500" prepend-icon="mdi-plus"
          >เพิ่มลำดับ</Button
        >
      </div>
    </divcard>
    <divcard
      v-for="(prioritize, index) in form.area_form_2_8"
      :key="'area_form_2_8' + index"
      class="mx-7"
    >
      <v-btn
        icon
        absolute
        top
        right
        style="z-index: 99"
        @click="delPrioritize(index)"
      >
        <Iconify
          class="font-18"
          style="color: #b1b1b1"
          icon="mdi:close-circle"
        />
      </v-btn>
      <div>
        <div class="flex-center gap-16">
          <div class="flex">
            <div class="mb-1 black--text">
              {{
                "8." +
                (index + 1) +
                " ลำดับ " +
                (index + 1) +
                " (" +
                (index + 1) +
                (index + 1 === 1
                  ? "st"
                  : index + 1 === 2
                  ? "nd"
                  : index + 1 === 3
                  ? "rd"
                  : "th") +
                " Priority)"
              }}
            </div>
            <div class="mb-1 black--text">ประเภทห้องที่ต้องการ</div>
            <TextField
              theme="3"
              :value="prioritize.room_type"
              @onChange="setPrioritizeField('room_type', index, $event)"
            >
            </TextField>
            <div class="mb-1 black--text">ขนาดห้อง ตร.ม</div>
            <TextField
              input-type="number"
              theme="3"
              :value="prioritize.room_size"
              @onChange="setPrioritizeField('room_size', index, $event)"
            >
            </TextField>
          </div>
        </div>
      </div>
    </divcard>
    <divcard>
      <div class="d-flex justify-space-between">
        <div class="txt-head black--text mb-2">
          9. ความต้องการใช้พื้นที่อาคาร (Space Requirement)
        </div>
        <Button @onClick="addPerson2" theme="500" prepend-icon="mdi-plus"
          >เพิ่มข้อมูลบุคคล</Button
        >
      </div>
      <div class="mb-1 black--text">
        ประเภทการใช้พื้นที่ (Type of Space Requirement)
      </div>
      <v-radio-group style="width: 100%" v-model="form.space_requirement_type">
        <v-radio
          color="var(--theme-color-one)"
          label="สำนักงานเพื่อการวิจัยและพัฒนาสำหรับผู้ประกอบการขนาดเล็ก กลาง ใหญ่ (R&D Office for SML Enterprises)"
          value="สำนักงานเพื่อการวิจัยและพัฒนาสำหรับผู้ประกอบการขนาดเล็ก กลาง ใหญ่ (R&D Office for SML Enterprises)"
        ></v-radio>
        <v-radio
          color="var(--theme-color-one)"
          value="สำนักงานเพื่อการจัดตั้งธุรกิจนวัตกรรม (Startup)"
        >
          <template v-slot:label>
            {{ "สำนักงานเพื่อการจัดตั้งธุรกิจนวัตกรรม (Startup) " }}
            <span class="theme-color-one">
              โปรดเลือก (Startups' Office, please select one option below)
            </span>
          </template></v-radio
        >
      </v-radio-group>
      <v-radio-group
        class="mx-7"
        row
        style="width: 100%"
        v-model="form.space_requirement_startup"
      >
        <v-row>
          <v-col cols="4">
            <v-radio
              :disabled="
                form.space_requirement_type !==
                'สำนักงานเพื่อการจัดตั้งธุรกิจนวัตกรรม (Startup)'
              "
              label="Fixed Desk"
              value="Fixed Desk"
              color="var(--theme-color-one)"
            ></v-radio>
          </v-col>
          <v-col cols="4">
            <v-radio
              :disabled="
                form.space_requirement_type !==
                'สำนักงานเพื่อการจัดตั้งธุรกิจนวัตกรรม (Startup)'
              "
              label="Startup Office (2-4 persons)"
              value="Startup Office (2-4 persons)"
              color="var(--theme-color-one)"
            ></v-radio>
          </v-col>
          <v-col cols="4">
            <v-radio
              :disabled="
                form.space_requirement_type !==
                'สำนักงานเพื่อการจัดตั้งธุรกิจนวัตกรรม (Startup)'
              "
              label="Startup Office (4-6 persons)"
              value="Startup Office (4-6 persons)"
              color="var(--theme-color-one)"
            ></v-radio>
          </v-col>
          <v-col cols="4">
            <v-radio
              :disabled="
                form.space_requirement_type !==
                'สำนักงานเพื่อการจัดตั้งธุรกิจนวัตกรรม (Startup)'
              "
              label="Startup Office (8-10 persons)"
              value="Startup Office (8-10 persons)"
              color="var(--theme-color-one)"
            ></v-radio>
          </v-col>
        </v-row>
      </v-radio-group>
    </divcard>
    <divcard
      v-for="(value, index) in form.area_form_2_9"
      :key="'area_form_2_9' + index"
      class="mx-7"
    >
      <div class="mb-1 black--text">
        {{ "9." + (index + 1) + " คนที่ " + (index + 1) }}
      </div>
      <v-btn
        icon
        absolute
        top
        right
        style="z-index: 99"
        @click="delPerson2(index)"
      >
        <Iconify
          class="font-18"
          style="color: #b1b1b1"
          icon="mdi:close-circle"
        />
      </v-btn>
      <div>
        <div>
          <div class="mb-1 black--text">บุคคลที่ {{ index + 1 }} ทำหน้าที่</div>
          <TextField
            theme="3"
            :value="value.position"
            @onChange="setPerson2Field('position', index, $event)"
          >
          </TextField>
        </div>
      </div>
    </divcard>
    <divcard>
      <div class="txt-head black--text mb-2">
        10. การสนับสนุนหรือให้บริการแก่ผู้ใช้งานอาคารฯ รายอื่นๆ (Products or
        Service to Contribute for Regional Science Park, North (RSP North)
        Ecosystem)
      </div>
      <div class="mb-1 black--text">
        การสนับสนุนหรือให้บริการแก่ผู้ใช้งานอาคารฯ รายอื่นๆ (Products or Service
        to Contribute for Regional Science Park, Ecosystem)
      </div>
      <TextField
        theme="3"
        :value="form.product_service_eco"
        @onChange="setFormField('product_service_eco', $event)"
      >
      </TextField>
    </divcard>
    <divcard>
      <div class="txt-head black--text mb-2">
        11. สัดส่วนการบริหารจัดการพื้นที่ต่อพื้นที่ทั้งหมด 100% (Space
        Utilization Ratio)
      </div>
      <CheckBox
        style="max-width: unset"
        :input-value="form.space_ratio_lab"
        @onChange="form.space_ratio_lab = $event"
        >อัตราการใช้พื้นที่สำหรับเป็นห้องปฏิบัติการ หรือหน่วยงานวิจัยพัฒนา
        (Laboratiory/R&D Unit) เปอร์เซ็นต์ (Percent)</CheckBox
      >
      <TextField
        :disabled="!form.space_ratio_lab"
        theme="3"
        input-type="number"
        :value="form.space_ratio_lab_percent"
        @onChange="setFormField('space_ratio_lab_percent', $event)"
      >
      </TextField>
      <CheckBox
        style="max-width: unset"
        :input-value="form.space_ratio_office"
        @onChange="form.space_ratio_office = $event"
        >อัตราการใช้พื้นที่สำหรับเป็นสำนักงาน (Office) เปอร์เซ็นต์
        (Percent)</CheckBox
      >
      <TextField
        :disabled="!form.space_ratio_office"
        theme="3"
        input-type="number"
        :value="form.space_ratio_office_percent"
        @onChange="setFormField('space_ratio_office_percent', $event)"
      >
      </TextField>
    </divcard>
    <divcard>
      <div class="txt-head black--text mb-2">
        12. การบริหารงานของบริษัท / หน่วยงาน
        ภายในพื้นที่อาคารอำนวยการอุทยานวิทยาศาสตร์ (Type of area usage)
      </div>
      <v-radio-group
        style="width: 100%"
        v-model="form.type_of_area_usage"
        @change="handleAreaUsageChange"
      >
        <v-radio
          color="var(--theme-color-one)"
          label="สำนักงานใหญ่ (Head Office)"
          value="สำนักงานใหญ่ (Head Office)"
        ></v-radio>
        <v-radio
          color="var(--theme-color-one)"
          label="สำนักงานสาขา (Branch office)"
          value="สำนักงานสาขา (Branch office)"
        ></v-radio>
        <v-radio
          color="var(--theme-color-one)"
          label="จัดตั้งศูนย์วิจัยและพัฒนา โปรระบุชื่อศูนย์ฯ (Research & Development Center), Please specify Center's name"
          value="จัดตั้งศูนย์วิจัยและพัฒนา (Research & Development Center)"
        ></v-radio>
        <div class="flex-center gap-16">
          <div class="flex">
            <div class="mb-1 black--text">ภาษาไทย (Thai)</div>
            <TextField
              :disabled="
                form.type_of_area_usage !==
                `จัดตั้งศูนย์วิจัยและพัฒนา (Research & Development Center)`
              "
              theme="3"
              :value="form.type_of_area_usage_th"
              @onChange="setFormField('type_of_area_usage_th', $event)"
            >
            </TextField>
          </div>

          <div class="flex">
            <div class="mb-1 black--text">ภาษาอังกฤษ (English)</div>
            <TextField
              :disabled="
                form.type_of_area_usage !==
                `จัดตั้งศูนย์วิจัยและพัฒนา (Research & Development Center)`
              "
              theme="3"
              :value="form.type_of_area_usage_eng"
              @onChange="setFormField('type_of_area_usage_eng', $event)"
            >
            </TextField>
          </div>
        </div>
        <v-radio
          color="var(--theme-color-one)"
          label="อื่นๆ (โปรดระบุ)"
          value="อื่นๆ"
        ></v-radio>
        <TextField
          :disabled="form.type_of_area_usage !== 'อื่นๆ'"
          theme="3"
          :value="form.type_of_area_usage_other"
          @onChange="setFormField('type_of_area_usage_other', $event)"
        >
        </TextField>
      </v-radio-group>
    </divcard>
  </div>
</template>

<script>
import TextField from "../../components/input/TextField";
import SwitchInset from "../../components/input/SwitchInset";
import AutoBox from "../../components/input/AutoBox";
import Button from "@/components/input/Button";
import CheckBox from "../../components/input/CheckBox";
import DatePicker from "../../components/input/DatePicker";
import { eventBus, validateEmail } from "../../plugins/global-funcs";
import { mapState } from "vuex";

export default {
  name: "SecondForm",
  components: {
    TextField,
    SwitchInset,
    AutoBox,
    Button,
    CheckBox,
    DatePicker,
  },
  props: {
    masterData: Object,
    formData: Object,
  },
  data() {
    return {
      form: {
        area_form_2_3: [],
        area_form_2_8: [],
        area_form_2_9: [],
        industry_food: false,
        industry_ict: false,
        industry_science: false,
        industry_materials: false,
        industry_electronics: false,
        industry_medical: false,
        industry_auto: false,
        industry_others: false,

        space_ratio_lab: false,
        space_ratio_office: false,
      },

      websiteRules: [
        (v) => !!v || "",
        (v) => /^(http|https):\/\/[^ "]+$/.test(v) || "เว็บไซต์ไม่ถูกต้อง",
      ],
      zipCodeRules: [
        (v) => !!v || "",
        (v) => (v && v.length === 5) || "รหัสไปรษณีย์ต้องมี 5 หลัก",
      ],
      emailRules: [
        (v) => !!v || "",
        (v) => validateEmail(v) || "อีเมลไม่ถูกต้อง",
      ],
      mobilePhoneRules: [
        (v) => !!v || "",
      ],
      pidRules: [
        (v) => !!v || "",
        (v) => (v && v.length === 13) || "เลขประจำตัวประชาชนต้องมี 13 หลัก",
      ],
    };
  },
  computed: {
    ...mapState({}),
  },
  created() {
    eventBus.$on("secondForm", () => {
      eventBus.$emit("secondFormSend", this.form);
    });
    eventBus.$emit("secondFormSend", this.form);
  },
  watch: {
    formData: {
      handler(newValue) {
        this.form = JSON.parse(JSON.stringify(newValue));
        this.form.area_form_2_3 = this.form.area_form_2_3 || [];
        this.form.area_form_2_8 = this.form.area_form_2_8 || [];
        this.form.area_form_2_9 = this.form.area_form_2_9 || [];
        this.form.industry_food = this.form.industry_food || false;
        this.form.industry_ict = this.form.industry_ict || false;
        this.form.industry_science = this.form.industry_science || false;
        this.form.industry_materials = this.form.industry_materials || false;
        this.form.industry_electronics =
          this.form.industry_electronics || false;
        this.form.industry_medical = this.form.industry_medical || false;
        this.form.industry_auto = this.form.industry_auto || false;
        this.form.industry_others = this.form.industry_others || false;

        this.form.space_ratio_lab = this.form.space_ratio_lab || false;
        this.form.space_ratio_office = this.form.space_ratio_office || false;
      },
      deep: true,
      immediate: true,
    },
    form: {
      handler(newValue) {
        if (
          newValue?.space_requirement_type !=
          "สำนักงานเพื่อการจัดตั้งธุรกิจนวัตกรรม (Startup)"
        ) {
          this.form.space_requirement_startup = null;
        }
        if (!newValue?.space_ratio_lab) {
          this.form.space_ratio_lab_percent = null;
        }
        if (!newValue?.space_ratio_office) {
          this.form.space_ratio_office_percent = null;
        }
        if (!newValue?.industry_others) {
          this.form.industry_others_specify = null;
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    handleAreaUsageChange(newValue) {
      if (newValue === "อื่นๆ") {
        this.form.type_of_area_usage_th = null;
        this.form.type_of_area_usage_eng = null;
      } else if (
        newValue === "จัดตั้งศูนย์วิจัยและพัฒนา (Research & Development Center)"
      ) {
        this.form.type_of_area_usage_other = null;
      } else {
        this.form.type_of_area_usage_th = null;
        this.form.type_of_area_usage_eng = null;
        this.form.type_of_area_usage_other = null;
      }
    },
    setFormField(field, val) {
      this.form[field] = val;
      this.$forceUpdate();
    },
    addPerson() {
      this.form.area_form_2_3.push({});
    },
    delPerson(index) {
      this.form.area_form_2_3.splice(index, 1);
    },
    setPersonField(field, i, val) {
      this.form.area_form_2_3[i][field] = val;
      this.$forceUpdate();
    },
    addPrioritize() {
      this.form.area_form_2_8.push({});
    },
    delPrioritize(index) {
      this.form.area_form_2_8.splice(index, 1);
    },
    setPrioritizeField(field, i, val) {
      this.form.area_form_2_8[i][field] = val;
      this.form.area_form_2_8[i].no = i + 1;
      this.$forceUpdate();
    },

    addPerson2() {
      this.form.area_form_2_9.push({});
    },
    delPerson2(index) {
      this.form.area_form_2_9.splice(index, 1);
    },
    setPerson2Field(field, i, val) {
      this.form.area_form_2_9[i][field] = val;
      this.form.area_form_2_9[i].no = i + 1;
      this.$forceUpdate();
    },
  },
};
</script>

<style></style>
